import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/ticket`;
const apiReportPath = `${store.state.apiPathWithVersion}/report`;

export default {
  async sendEmail(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    params.email = true;

    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/download`, {
        params: params
      });
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async downloadFile(params, filename) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    params.email = false;

    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/download`, {
        params: params,
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${filename}.pdf`);
      document.body.appendChild(link);
      link.click();

      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async sendEmailList(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    params.email = true;

    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/downloadList`, {
        params: params
      });
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async downloadFileList(params, filename) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    params.email = false;

    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/downloadList`, {
        params: params,
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${filename}.pdf`);
      document.body.appendChild(link);
      link.click();

      // let resp = await axios({
      //   url: `${apiUrl}/${apiPath}/downloadList`,
      //   params: params,
      //   method: 'GET',
      //   responseType: 'blob' // important
      // });
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },
  async sendReportEmail(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    params.email = true;

    try {
      let resp = await axios.get(`${apiUrl}/${apiReportPath}/${params.reportType}`, {
        params: params
      });
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async downloadReportFile(params, filename) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    params.email = false;

    try {
      let resp = await axios.get(`${apiUrl}/${apiReportPath}/${params.reportType}`, {
        params: params,
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${filename}.pdf`);
      document.body.appendChild(link);
      link.click();

      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  }
};

// import axios from 'axios';
// import store from '@/store';

// const apiPath = '/user/ticket';

// export default {
//   download(params) {
//     let apiUrl = store.state.countrySelected.api;

//     axios({
//       url: `${apiUrl}/${apiPath}/download`,
//       params: params,
//       method: 'GET',
//       responseType: 'blob' // important
//     }).then(response => {
//       // const blob = req.response;
//       // const url = window.URL.createObjectURL(new Blob([response.data]));
//       // const link = document.createElement('a');
//       // link.href = url;
//       // link.setAttribute('download', 'file.pdf');
//       // document.body.appendChild(link);
//       // link.click();

//       const link = document.createElement('a');

//       const filename = response.headers['X-WSP-Download-Filename'];
//       const contentType = response.headers['Content-Type'];
//       const url = window.URL.createObjectURL(new Blob([response.data]));

//       link.href = url;
//       link.download = filename;
//       document.body.appendChild(link);
//       link.click();
//     });
//   }
// };
